import './Tabs.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "root": "Tabs_root__l58ms",
    "list": "Tabs_list__l58ms",
    "primaryList": "Tabs_primaryList__l58ms",
    "secondaryList": "Tabs_secondaryList__l58ms",
    "primary": "Tabs_primary__l58ms",
    "secondary": "Tabs_secondary__l58ms",
    "trigger": "Tabs_trigger__l58ms"
};
